'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles((theme)=>{
    return {
        root: {
            paddingBottom: 0,
            [theme.fn.up('sm1')]: {
                paddingBottom: rem(32)
            }
        },
        dropdown: {
            borderRadius: theme.fn.borderRadius('1.5'),
            [theme.fn.up('sm1')]: {
                borderRadius: theme.fn.borderRadius('3r')
            }
        },
        content: {
            padding: 0,
            maxHeight: 'min-content',
            display: 'inline',
            background: theme.palette.background.highlight
        },
        wrapper: {
            position: 'relative',
            height: rem(68),
            borderRadius: theme.fn.borderRadius('1.5'),
            [theme.fn.up('sm1')]: {
                borderRadius: theme.fn.borderRadius('3r')
            }
        },
        input: {
            '&[data-right-section=false]': {
                paddingRight: 32
            },
            '&[data-left-section=false]': {
                paddingLeft: 32
            },
            '&::placeholder': {
                color: theme.palette.text.quaternary,
                fontSize: rem(20),
                lineHeight: rem(28),
                fontWeight: 600
            },
            fontSize: rem(20),
            lineHeight: rem(28),
            fontWeight: 600
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=FooterSearch.styles.js.map
